/*
 * Shared layout rules for calculator output rows.
 *
 * A saved calculation is rendered in two places — the worksheet panel inside
 * the calculator, and the saved-calculations list in the project view. They
 * must lay out identically, so the rule that decides how a row is drawn lives
 * here rather than being written twice and drifting.
 */

/*
 * Several calculators emit narrative rows rather than figures: the TAN method
 * explanation, the saltwater derate note, the "check the rate" caveat. Those
 * carry no unit and run to a sentence or more. Rendering them with the label
 * left and the value right-aligned — correct for "Reactor volume | 34.07 m³" —
 * turns a paragraph into a ragged column a few words wide. Prose stacks under
 * its label instead.
 *
 * Keyed on the absence of a unit plus length: a unit means a measurement, and
 * short unitless values ("Freshwater", "Sodium bicarbonate") still read fine as
 * a right-hand value. 28 characters is where a value stops fitting the
 * right-hand column at 375px, which is the narrowest layout either view has.
 */
export const PROSE_MIN_LENGTH = 28;

export const isProseOutput = (o) =>
  !!o && !o.unit && String(o.value ?? '').length > PROSE_MIN_LENGTH;

export default isProseOutput;
